import { AbstractControl, ValidatorFn } from '@angular/forms';

/**
 * https://pt.wikipedia.org/wiki/Cadastro_de_pessoas_f%C3%ADsicas#Algoritmo
 */
export const validateCPF = (): ValidatorFn => (
  control: AbstractControl,
): { [key: string]: string } | null => {
  const errorMessage = {
    CPF_ERROR:
      'Please provide a valid CPF containing exactly 11 digits without any special characters',
  };
  const value: string = control.value || '';
  const digits = value.split('').map(Number);
  if (digits.length !== 11) {
    return errorMessage;
  }
  const checkIndistinctDigits = new Set(digits);
  if (checkIndistinctDigits.size < 2) {
    return errorMessage;
  }
  const firstNineDigits = digits.slice(0, 9);
  let v1 = 0;
  let v2 = 0;
  firstNineDigits.reverse().forEach((v, i) => {
    v1 += v * (9 - (i % 10));
    v2 += v * (9 - ((i + 1) % 10));
  });
  v1 = (v1 % 11) % 10;
  v2 = ((v2 + v1 * 9) % 11) % 10;
  if (v1 !== digits[9] || v2 !== digits[10]) {
    return errorMessage;
  }
  return null;
};
